import baseURL from '../../../api/api'
import { axiosPrivate } from '../../../services/makeRequest'

export function getRegistrationData() {
    return axiosPrivate(`${baseURL}/users/registration`, {
        method: 'GET',
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}

export function registerUser({
    email,
    password,
    firstName,
    lastName,
    mobile,
    staffNumber,
    airline_id,
}) {
    return axiosPrivate(`${baseURL}/users`, {
        method: 'POST',
        data: { email, password, firstName, lastName, mobile, staffNumber, airline_id },
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}

export function cancelRegistration({ token }) {
    return axiosPrivate('users/registration', {
        method: 'DELETE',
        headers: {
            authorization: `Bearer ${token}`,
        },
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}
